export default "__VITE_ASSET__DKGq2JnK__"